// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsModelsEnumsInsurancePriority } from './clsModelsEnumsInsurancePriority.js';
import type { ClsModelsEnumsRelationshipToPatient } from './clsModelsEnumsRelationshipToPatient.js';
import type { IAddress } from './iAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IPayor {
    'payorId'?: string;
    'payorName': string;
    'phoneNumber'?: string;
    'faxNumber'?: string;
    'groupNumber'?: string;
    'policyNumber'?: string;
    'planEffectiveDate'?: string;
    'planExpirationDate'?: string;
    'planTerminationDate'?: string;
    'policyName'?: string;
    'policyHolderFirstName'?: string;
    'policyHolderLastName'?: string;
    'insurancePriority'?: ClsModelsEnumsInsurancePriority;
    'relationshipToPatient'?: ClsModelsEnumsRelationshipToPatient;
    'address'?: IAddress | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IPayor>> = [
        {
            "name":     "payorId",
            "baseName": "payorId",
            "type":     "string"
        },
        {
            "name":     "payorName",
            "baseName": "payorName",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "faxNumber",
            "baseName": "faxNumber",
            "type":     "string"
        },
        {
            "name":     "groupNumber",
            "baseName": "groupNumber",
            "type":     "string"
        },
        {
            "name":     "policyNumber",
            "baseName": "policyNumber",
            "type":     "string"
        },
        {
            "name":     "planEffectiveDate",
            "baseName": "planEffectiveDate",
            "type":     "string"
        },
        {
            "name":     "planExpirationDate",
            "baseName": "planExpirationDate",
            "type":     "string"
        },
        {
            "name":     "planTerminationDate",
            "baseName": "planTerminationDate",
            "type":     "string"
        },
        {
            "name":     "policyName",
            "baseName": "policyName",
            "type":     "string"
        },
        {
            "name":     "policyHolderFirstName",
            "baseName": "policyHolderFirstName",
            "type":     "string"
        },
        {
            "name":     "policyHolderLastName",
            "baseName": "policyHolderLastName",
            "type":     "string"
        },
        {
            "name":     "insurancePriority",
            "baseName": "insurancePriority",
            "type":     "ClsModelsEnumsInsurancePriority"
        },
        {
            "name":     "relationshipToPatient",
            "baseName": "relationshipToPatient",
            "type":     "ClsModelsEnumsRelationshipToPatient"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "IAddress"
        },
    ];

    static getAttributeTypeMap() {
        return IPayor.attributeTypeMap;
    }
}
